import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { TOOLTIP } from '../../pages/constants';
import Icon from './Icon';
var IconWithTooltip = function(param) {
    var tooltipText = param.tooltipText, icon = param.icon;
    return /*#__PURE__*/ React.createElement(OverlayTrigger, {
        placement: "right",
        delay: {
            show: TOOLTIP.SHOW_DELAY,
            hide: TOOLTIP.HIDE_DELAY
        },
        overlay: /*#__PURE__*/ React.createElement(Tooltip, null, tooltipText)
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: "IconWithTooltip",
        icon: icon
    }));
};
export default IconWithTooltip;
